<template>
  <b-list-group
    v-if="getCustomer.customerName"
    class="d-inline float-lg-right cursor-pointer text-z-index"
    :class="{ shadow: hasShadow }"
  >
    <b-list-group-item
      v-b-modal.modal-customer-lock
      class="lc-z-index d-flex align-items-center"
    >
      <span class="font-weight-bold">Customer:</span>
      <span class="ml-2 mr-auto">{{ getCustomer.customerName }}</span>
      <span class="font-weight-bold ml-2"> Id:</span>
      <span class="ml-2">{{ getCustomer.cid }}</span>
    </b-list-group-item>
    <b-list-group-item
      v-if="showAdminAndPbx"
      class="lc-z-index d-flex align-items-center"
    >
      <span class="font-weight-bold mr-2">Admin:</span>
      <R-Select
        placeholder="Admin"
        :isClearable="false"
        :size="'small'"
        :options="sAdminOptions"
        ref="selectedAdmin"
        :class="'w-100'"
        :value="selectedAdmin"
        @onChange="
          $event
            ? (selectedAdmin = { label: $event.label, value: $event.value })
            : (selectedAdmin = null);
          lockCustomer('admin');
        "
        style="max-width: 340px; min-width: 220px"
      ></R-Select>

      <template v-if="selectedPbx">
        <span class="font-weight-bold mx-2"> Pbx: </span>
        <R-Select
          placeholder="Pbx"
          :isClearable="false"
          :size="'small'"
          :options="sPbxOptions"
          ref="selectedPbx"
          :class="'w-100'"
          :value="selectedPbx"
          @onChange="
            $event
              ? (selectedPbx = { label: $event.label, value: $event.value })
              : (selectedPbx = null);
            lockCustomer('pbx');
          "
          style="min-width: 220px"
        ></R-Select>
        <a
          class="text-link pl-2"
          target="_blank"
          :href="'https://8x8.tools/intraswitch/?pbx=' + selectedPbx.label"
        >
          <DatabaseIcon :link="true" :color="'#A4B8D1'"></DatabaseIcon>
        </a>
      </template>
    </b-list-group-item>
  </b-list-group>
  <b-alert
    v-else
    show
    v-b-modal.modal-customer-lock
    variant="warning"
    class="mb-0 d-inline-block float-lg-right cursor-pointer"
    :class="{ shadow: hasShadow }"
  >
    <span class="font-weight-bold mr-auto">Customer:</span>
    <span class="ml-2 mr-auto">No customer selected!</span>
  </b-alert>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";

export default {
  name: "locked-customer",
  props: {
    hasShadow: {
      default: true,
      type: Boolean,
    },
    showAdminAndPbx: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      selectedPbx: null,
      selectedAdmin: null,
    };
  },
  computed: {
    ...mapGetters(["getCustomer"]),
    /***  SETTING VALUES ***/
    sPbxOptions() {
      let options = [];
      if (this.getCustomer.pbxList) {
        this.getCustomer.pbxList.forEach((pbx, key) => {
          options.push({
            value: pbx.value,
            label: pbx.name,
          });
        });
      }

      return options;
    },
    sAdminOptions() {
      let options = [];
      if (this.getCustomer.adminList) {
        this.getCustomer.adminList.forEach((admin, key) => {
          options.push({
            value: admin,
            label: admin,
          });
        });
      }

      return options;
    },
  },
  watch: {
    getCustomer(newValue, oldValue) {
      if (newValue.pbx) {
        this.selectedPbx = {
          value: newValue.pbx,
          label: newValue.pbx.name,
        };

        this.selectedAdmin = {
          value: newValue.lid,
          label: newValue.lid,
        };
      }
    },
  },
  methods: {
    ...mapActions(["fetchCustomer"]),
    async lockCustomer(item) {
      let lockingToast = notify({
        content: "Changing " + item + "...",
        duration: DURATION.INFINITE,
      });

      this.fetchCustomer({
        customerId: this.getCustomer.cid,
        pbx: this.selectedPbx.value,
        pbxList: this.getCustomer.pbxList,
        adminList: this.getCustomer.adminList,
        customerName: this.getCustomer.customerName,
        tenantInfo: this.getCustomer.tenantInfo,
        success: (response) => {
          lockingToast.close();
          console.log("got lockCustomer");
          console.log(response);
          let message =
            "Switched " +
            item +
            " to " +
            (item == "pbx" ? this.selectedPbx.label : this.selectedAdmin.label);
          notify({ content: message, duration: 5000 });
          EventBus.$emit("lock-customer");
        },
        error: (response) => {
          lockingToast.close();
          console.log("got error lockCustomer");
          console.log(response);
          notify({
            content: response,
            type: TYPE.error,
            duration: DURATION.INFINITE,
          });
        },
      });
    },
  },
  created() {
    if (this.getCustomer.pbx) {
      this.selectedPbx = {
        value: this.getCustomer.pbx,
        label: this.getCustomer.pbx.name,
      };
    }

    if (this.getCustomer.lid) {
      this.selectedAdmin = {
        value: this.getCustomer.lid,
        label: this.getCustomer.lid,
      };
    }
  },
};
</script>
